import { Badge } from '@/components/ui/badge';
import { formatCurrency } from '@/lib/utils';
import {
  getZraExemptAllowanceLines,
} from '@/lib/payrollAllowances';

interface AllowancePayeBadgesProps {
  payslip: {
    allowanceBreakdown?: { id?: string | number; name?: string; amount?: number; type?: string }[];
    allowance_breakdown?: { id?: string | number; name?: string; amount?: number; type?: string }[];
  };
  compact?: boolean;
  /** When true (default on Approvals), only ZRA-exempt allowances are shown. */
  exemptOnly?: boolean;
}

export const AllowancePayeBadges = ({
  payslip,
  compact = false,
  exemptOnly = true,
}: AllowancePayeBadgesProps) => {
  const lines = exemptOnly
    ? getZraExemptAllowanceLines(payslip)
    : (payslip.allowanceBreakdown ?? payslip.allowance_breakdown ?? []).filter((line) => line.name);

  if (lines.length === 0) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  return (
    <div className={`flex flex-wrap gap-1 ${compact ? 'max-w-[220px]' : 'max-w-xs'}`}>
      {lines.map((line, index) => (
        <Badge
          key={`${line.name}-${index}`}
          variant="outline"
          className="bg-slate-50 text-slate-700 border-slate-200 text-[10px] font-normal"
          title={`${line.name}: ${formatCurrency(Number(line.amount ?? 0))} (ZRA exempt)`}
        >
          {line.name}
          {!compact && line.amount != null ? ` ${formatCurrency(Number(line.amount))}` : ''}
          {' · Exempt'}
        </Badge>
      ))}
    </div>
  );
};
